__turbopack_context__.v({
  "body": "styles-module__dU0nfG__body",
  "content": "styles-module__dU0nfG__content",
  "hero": "styles-module__dU0nfG__hero",
  "heroEyebrow": "styles-module__dU0nfG__heroEyebrow",
  "heroInner": "styles-module__dU0nfG__heroInner",
  "heroLede": "styles-module__dU0nfG__heroLede",
  "heroTitle": "styles-module__dU0nfG__heroTitle",
  "list": "styles-module__dU0nfG__list",
  "root": "styles-module__dU0nfG__root",
  "section": "styles-module__dU0nfG__section",
  "sectionAlt": "styles-module__dU0nfG__sectionAlt",
  "sectionHeading": "styles-module__dU0nfG__sectionHeading",
  "strong": "styles-module__dU0nfG__strong",
  "subHeading": "styles-module__dU0nfG__subHeading",
});
